import React, { useCallback } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { Declined } from 'src/shared/assets/svg';
import { useHistory } from 'react-router-dom';
import { routes } from 'src/shared/constants';
import { useStyles } from './styles';

const ExpiredHyperlink = () => {
  const classes = useStyles();
  const { push } = useHistory();

  const returnToHome = useCallback(() => {
    push(routes.home.path);
  }, [push]);

  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <Typography className={classes.title}>
          Ops! Não foi possível prosseguir com a sua emissão...
        </Typography>
      </Grid>

      <Grid item xs={12} className={classes.alignCenter}>
        <img src={Declined} alt="Under Evaluation" className={classes.image} />
      </Grid>

      <Grid item xs={10} md={4} lg={4} xl={3} className={classes.alignCenter}>
        <Typography className={classes.textInfo}>
          O link que você acessou não é mais válido. Em caso de dúvidas, entre em contato com o
          nosso time comercial.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container justify="center" className={classes.btnContainer}>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              onClick={returnToHome}
              className={classes.button}
            >
              Voltar ao início
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ExpiredHyperlink;
